import checkout from "./form";

const {
  formField: {
    fullName,
    chiefAccountant,
    signer,
    timeSign,

    taxpayersName,
    taxpayersId,

    htldl,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [chiefAccountant.name]: "",

  [taxpayersName.name]: "",
  [taxpayersId.name]: "",

  [htldl.name]: false,
};

export default initialValues;
